import React, { useContext, useRef } from "react";
import { StateContext } from "../../state/index";
import BaseContent from '../BaseContent';
import { useCustomCSS } from "../../utils/hooks";
import { BROWSER_STORAGE_ITEMS } from "../../utils/enums";

export const PaymentComplete = () => {
  const [{configuration}] = useContext(StateContext);
  const componentRef = useRef();
  useCustomCSS(componentRef, 'paymentComplete');

  window.sessionStorage.removeItem(BROWSER_STORAGE_ITEMS.INITIAL_COMPLETE);

  return (
    <BaseContent {...configuration.paymentComplete} ref={componentRef} />
  );
};

export default PaymentComplete;
